import "./operatorScreen.css";
import dp from "./dp.png";
import React, { useEffect, useState, useContext, useRef } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useParams, useNavigate} from "react-router-dom";
import {Defects} from "./Defects";
import { AuthInfo } from "../../../../../App";
import { devMode, host, locale } from "../../../../../utils";
import LockScreen from "../../../../LockScreen/LockScreen";
import { useDispatch } from "react-redux";
import { saveSelectedLine, saveSelectedMachine, saveSelectedMachineType, saveSelectedPlant, saveSelectedShift } from "../../../../../redux/actions";





function OperatorScreen(props) {
  toast.configure();
  var { userId, userInfo } = useContext(AuthInfo);  
  const [status, setStatus] = useState({});
  const [showDefects, setShowDefects] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [operatorScreen, setOperatorScreen] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const baxeValue = useRef(null);

  const { planId } = useParams();


  if(!userInfo && devMode){
    userInfo = {
      profile: {
        name: "John Doe",
        gender: "-",
      },
      employment: {
        designation: "-",
        type: "-",
        permissions: [],
        sdplants: [],
      },
      tokens: [],
      roles: [],
      machines: [],
      createdAt: "-",
      updatedAt: "-",
      email: "john.doe@gmail.com"
    }
  }

  const defectsClick = () => {
    setShowDefects(true);
  };
  const openDowntimeTab = async function(){
    // window.open(
    //   `${host}/downtime?machineId=${operatorScreen.associatedProdPlans[0]["machineId"]}`
    // );

    //return;
    
    dispatch(saveSelectedPlant({ selectedOption: { value: operatorScreen.associatedProdPlans[0]["machineInfo"]["plantId"], label: operatorScreen.associatedProdPlans[0]["plantInfo"]["plantName"]}, InsIden: "downtime" }));
    dispatch(saveSelectedMachineType({ selectedOption: { value: operatorScreen.associatedProdPlans[0]["machineInfo"]["machineType"], label: operatorScreen.associatedProdPlans[0]["machineInfo"]["machineType"] }, InsIden: "downtime" }));
    dispatch(saveSelectedLine({ selectedOption: { value: operatorScreen.associatedProdPlans[0]["machineInfo"]["lineId"], label: operatorScreen.associatedProdPlans[0]["machineInfo"]["lineId"] }, InsIden: "downtime" }));
    dispatch(saveSelectedMachine({ selectedOption: { value: operatorScreen.associatedProdPlans[0]["machineInfo"]["machineId"], label: operatorScreen.associatedProdPlans[0]["machineInfo"]["machineName"] }, InsIden: "downtime" }));
    dispatch(saveSelectedShift({ selectedOption: { value: operatorScreen.associatedProdPlans[0]["plantInfo"]["shifts"][0]["shiftCode"], label: operatorScreen.associatedProdPlans[0]["plantInfo"]["shifts"][0]["shiftCode"] }, InsIden: "downtime" }));
    navigate("../../base/downtime?goback=true&initiate=true");
  };

  const submitBax = (e) => {
    e.preventDefault();
    console.log("Submitted", baxeValue.current.value);
  };

  const URL2 = `${host}/chartserver/mindaProductionPlanAnalysis?planId=${planId}&clubbedOperatorWindows=true`;
  const URL4 = `${host}/operator/plan/status`;

  const updatePlanStatus = async (planId, userId, status) => {
    fetch(URL4, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": "true",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
      },
      body: JSON.stringify({
        userId: userId,
        planningId: planId,
        status: status,
      }),
      //  credentials: 'include'
    })
      .then((res) => {
        if (res.status == 200) {
          toast.success("Job Status Updated", {
            position: toast.POSITION.TOP_LEFT,
          });
          getScreenData();
        } else if (res.status == 400 || res.status == 404) {
          toast.error("An error occured", {
            position: toast.POSITION.TOP_LEFT,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error("An error occured", { position: toast.POSITION.TOP_LEFT });
      });
  };


  const getScreenData = async () => {
    await axios.get(URL2).then((response) => {
      setOperatorScreen(response.data);

      if (response.data.associatedProdPlans == undefined) {
        alert("Unable get Production Plan data");
        let redirectTo = `${host}/operator/landing`;
        if (!devMode) {
          window.open(redirectTo, "_self");
        }
      }

      let Status = response.data.associatedProdPlans[0].status;
      if (Status == "RUNNING") {
        setStatus({ currStatus: "RUNNING", oppStatus: "PAUSED" });
      } else if (Status == "PAUSED") {
        setStatus({ currStatus: "PAUSED", oppStatus: "RUNNING" });
        let redirectTo = `${host}/operator/landing/${response.data.associatedProdPlans[0]["machineId"]}`;
        if (!devMode) {
          window.open(redirectTo, "_self");
        }
      } else if (Status == "COMPLETED") {
        setStatus({ currStatus: "COMPLETED" });
        let redirectTo = `${host}/operator/landing/${response.data.associatedProdPlans[0]["machineId"]}`;
        if (!devMode) {
          window.open(redirectTo, "_self");
        }
      }
      setLoading(false);
    });
  };



  useEffect(() => {
    getScreenData();
    setInterval(() => {
      getScreenData();
    }, 20000);
  }, []);

  if (isLoading) {
    return <div className="App">Loading...</div>;
  }

  return (
    <>      
      {(() => {
        if (props.showLS && !devMode) {
         return <LockScreen
            username={userInfo.email}
            setShow={props.setShowLS}
            show={props.showLS}
          />;
        }
      })()}
      <div className="container-fluid">
        <div className="box box-default">
          <div className="box-header">
            <h6>Current Production</h6>
          </div>
          <div className="box-body">
            <div className="row">
              <div className="col-lg-4 col-md-6">
                <div className="info-box">
                  <span className="info-box-icon bg-info">
                    <i className="fa fa-bar-chart"></i>
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Ideal Production</span>
                    {
                      <span className="info-box-number">
                        {operatorScreen.associatedProdPlans[0].idealProduction}
                      </span>
                    }
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="info-box">
                  <span className="info-box-icon bg-warning">
                    <i className="fa fa-bar-chart"></i>
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Actual Production</span>
                    {
                      <span className="info-box-number">
                        {operatorScreen.associatedProdPlans[0].actualProduction}
                      </span>
                    }
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6" onClick={defectsClick}>
                <div className="info-box">
                  <span className="info-box-icon bg-danger">
                    <i className="fa fa-ban"></i>
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Total Defects</span>
                    {
                      <span className="info-box-number">
                        {operatorScreen.associatedProdPlans[0].totalDefects}
                      </span>
                    }
                  </div>
                </div>
              </div>

              {// <div className="clearfix visible-sm-block"></div>
              }
              <div className="col-lg-4 col-md-6">
                <div className="info-box">
                  <span className="info-box-icon bg-primary">
                    <i className="fa fa-clock-o"></i>
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Total Time (hh:mm)</span>
                    <span className="info-box-number">
                      {
                        operatorScreen.associatedProdPlans[0]
                          .totalTimeElapsed_hhmm
                      }
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6" onClick={openDowntimeTab}>
                <div className="info-box">
                  <span className="info-box-icon bg-success">
                    <i className="fa fa-clock-o"></i>
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Downtime (hh:mm)</span>
                    <span className="info-box-number">
                      {operatorScreen.associatedProdPlans[0].downtime_hhmm}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="info-box">
                  <span className="info-box-icon bg-warning">
                    <i className="fa fa-percent"></i>
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">OEE</span>
                    {
                      <span className="info-box-number">
                        {operatorScreen.associatedProdPlans[0].oee + "%"}
                      </span>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-3">
                <div className="form-group row">
                  <div className="col-12 col-md-6 col-lg-12 px-3 text-center">
                    <img src={userInfo.profile.picture?userInfo.profile.picture:dp} className="img-thumbnail" alt="" />
                  </div>
                  <div className="col-12 col-md-6 col-lg-12">
                    <div className="mb-3 mt-3 mt-md-100">
                      {(() => {
                        if (status.currStatus == "RUNNING") {
                          return (
                            <button
                              className="btn btn-warning w-100"
                              type="button"
                              onClick={() => {
                                updatePlanStatus(
                                  planId,
                                  userId,
                                  status.oppStatus
                                );
                              }}
                            >
                              <i className="fa fa-pause"></i>
                              PAUSE
                            </button>
                          );
                        } else if (status.currStatus == "PAUSED") {
                          return (
                            <button
                              className="btn btn-success w-100"
                              type="button"
                              onClick={() => {
                                updatePlanStatus(
                                  planId,
                                  userId,
                                  status.oppStatus
                                );
                              }}
                            >
                              <i className="fa fa-play"></i>
                              RESUME
                            </button>
                          );
                        } else if (status.currStatus == "COMPLETED") {
                          return (
                            <button
                              className="btn btn-info w-100"
                              type="button"
                              disabled
                            >
                              <i className="fa fa-check"></i>
                              COMPLETED
                            </button>
                          );
                        }
                      })()}
                    </div>
                    <div className="mb-3">
                      <button
                        className="btn btn-danger w-100"
                        disabled={status.currStatus == "COMPLETED"}
                        type="button"
                        onClick={() => {
                          updatePlanStatus(planId, userId, "COMPLETED");
                        }}
                      >
                        <i className="fa fa-stop"></i> End Job
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-9">
                <div className="row">
                  <div className="col-md-6 mb-3 mt-3">
                    <div className="form-group row">
                      <label className="col-6">
                        Operator Name<span className="pull-right">:</span>
                      </label>
                      <label className="col-6 text-left">
                        {userInfo.profile.name}
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3 mt-3">
                    <div className="form-group row">
                      <label className="col-6">
                        Operator Rank<span className="pull-right">:</span>
                      </label>
                      <label className="col-6 text-left">-</label>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3 mt-3">
                    <div className="form-group row">
                      <label className="col-6">
                        Employee Id<span className="pull-right">:</span>
                      </label>
                      <label className="col-6 text-left">
                        {userInfo.email}
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3 mt-3">
                    <div className="form-group row">
                      <label className="col-6">
                        Machine Name <span className="pull-right">:</span>
                      </label>
                      {
                        <label className="col-6 text-left">
                          {
                            operatorScreen.associatedProdPlans[0][
                              "machineInfo"
                            ]["machineName"]
                          }
                        </label>
                      }
                    </div>
                  </div>
                  <div className="col-md-6 mb-3 mt-3">
                    <div className="form-group row">
                      <label className="col-6">
                        Order No<span className="pull-right">:</span>
                      </label>
                      {
                        <label className="col-6 text-left">
                          {operatorScreen.associatedProdPlans[0]["planningId"]}
                        </label>
                      }
                    </div>
                  </div>
                  <div className="col-md-6 mb-3 mt-3">
                    <div className="form-group row">
                      <label className="col-6">
                        Part Name<span className="pull-right">:</span>
                      </label>
                      {
                        <label className="col-6 text-left">
                          {operatorScreen.associatedProdPlans[0]["partId"]}
                        </label>
                      }
                    </div>
                  </div>
                  <div className="col-md-6 mb-3 mt-3">
                    <div className="form-group row">
                      <label className="col-6">
                        Part No<span className="pull-right">:</span>
                      </label>
                      {
                        <label className="col-6 text-left">
                          {operatorScreen.associatedProdPlans[0]["partId"]}
                        </label>
                      }
                    </div>
                  </div>
                  <div className="col-md-6 mb-3 mt-3">
                    <div className="form-group row">
                      <label className="col-6">
                        Planned Time (In hours)
                        <span className="pull-right">:</span>
                      </label>
                      {
                        <label className="col-6 text-left">
                          {
                            operatorScreen.associatedProdPlans[0][
                              "totalTime_hhmm"
                            ]
                          }{" "}
                          hh:mm
                        </label>
                      }
                    </div>
                  </div>
                  <div className="col-md-6 mb-3 mt-3">
                    <div className="form-group row">
                      <label className="col-6">
                        Planned Quantity<span className="pull-right">:</span>
                      </label>
                      {
                        <label className="col-6 text-left">
                          {
                            operatorScreen.associatedProdPlans[0][
                              "quantityPlanned"
                            ]
                          }
                        </label>
                      }
                    </div>
                  </div>
                  <div className="col-md-6 mb-3 mt-3">
                    <div className="form-group row">
                      <label className="col-6">
                        Start Time<span className="pull-right">:</span>
                      </label>
                      {
                        <label className="col-6 text-left">                          
                          {new Date(operatorScreen.associatedProdPlans[0]["actualStart"]).toLocaleString(locale)}
                        </label>
                      }
                    </div>
                  </div>
                  <div className="col-md-6 mb-3 mt-3">
                    <div className="form-group row">
                      <label className="col-6">
                        Consumed Time (In hours)
                        <span className="pull-right">:</span>
                      </label>
                      <label className="col-6 text-left">
                        {
                          operatorScreen.associatedProdPlans[0][
                            "totalTimeElapsed_hhmm"
                          ]
                        }{" "}
                        hh:mm
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3 mt-3">
                    <div className="form-group row">
                      <label className="col-6">
                        Produced Quantity<span className="pull-right">:</span>
                      </label>
                      {
                        <label className="col-6 text-left">
                          {
                            operatorScreen.associatedProdPlans[0][
                              "actualProduction"
                            ]
                          } ({operatorScreen.associatedProdPlans[0][
                            "strokes"
                          ] + " Shots x " +operatorScreen.associatedProdPlans[0][
                            "usedCavities"
                          ] + " Cavities"})
                        </label>
                      }
                    </div>
                  </div>
                  <div className="col-md-6 mb-3 mt-3">
                    <div className="form-group row">
                      <label className="col-6">
                        Defect Recording<span className="pull-right">:</span>
                      </label>
                      {
                        <label className="col-6 text-left">
                          {operatorScreen.associatedProdPlans[0].totalDefects}
                        </label>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/*
        <form>
          <label>
            Name:
            <input type="text" name="name" ref={baxeValue} />
          </label>
          <input type="submit" value="Submit" onClick={submitBax} />
        </form>
        */}
      </div>

      <Defects
        showDefects={showDefects}
        setShowDefects={setShowDefects}
        planningId={planId}
        actualProduction={
          operatorScreen.associatedProdPlans[0].actualProduction
        }
      />
    </>
  );
}

export default OperatorScreen;
